import { defineComponent } from "vue";

import { COMPONENT_NAME } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    answered: { type: Number, required: true },
    total: { type: Number, required: true },
    message: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
  },
});
